import { DrillFormComponent } from "@/components/forms/drill-form";
import { HseqVisitFormComponent } from "@/components/forms/hseq-visit";
import { InvestigationFormComponent } from "@/components/forms/investigations";
import { ManagementFormComponent } from "@/components/forms/management";
import { ObservationFormComponent } from "@/components/forms/observations";
import { formTypeSchema } from "@eiralab/backend/schemas";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

const formSearchSchema = z.object({
  formType: formTypeSchema,
});

// TODO: potentially
export const Route = createFileRoute(
  "/(dashboard)/_authenticated/$companyId/team/$teamId/f/$formId/",
)({
  component: RouteComponent,
  validateSearch: zodValidator(formSearchSchema),
});

function RouteComponent() {
  const { companyId, teamId, formId } = Route.useParams();
  const { formType } = Route.useSearch();

  switch (formType) {
    case "drill":
      return (
        <DrillFormComponent
          companyId={companyId}
          teamId={teamId}
          formId={formId}
        />
      );
    case "hseq_visit":
      return (
        <HseqVisitFormComponent
          companyId={companyId}
          teamId={teamId}
          formId={formId}
        />
      );
    case "investigation":
      return (
        <InvestigationFormComponent
          companyId={companyId}
          teamId={teamId}
          formId={formId}
        />
      );
    case "observation":
      return (
        <ObservationFormComponent
          companyId={companyId}
          teamId={teamId}
          formId={formId}
        />
      );
    case "management":
      return (
        <ManagementFormComponent
          companyId={companyId}
          teamId={teamId}
          formId={formId}
        />
      );
    case "mailbox":
      return null;
    default:
      // biome-ignore lint/correctness/noSwitchDeclarations: <explanation>
      const never: never = formType;
      return null;
  }
}
